import { render, staticRenderFns } from "./Licencias.vue?vue&type=template&id=76f70e8a&scoped=true"
import script from "./Licencias.vue?vue&type=script&lang=js"
export * from "./Licencias.vue?vue&type=script&lang=js"
import style0 from "./Licencias.vue?vue&type=style&index=0&id=76f70e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f70e8a",
  null
  
)

export default component.exports